<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-navigation-drawer :mini-variant.sync="mini" app v-model="drawer">
            <span v-if="smallImage">
                <v-list-item>
                    <img src="../../../../assets/gfi.png" style="width: 100%; height: auto "/>
                </v-list-item>
            </span>
            <span v-else>
               <v-list-item>
                    <img src="../../../../assets/gfi.png" style="width: 100%; height: auto "/>
            </v-list-item>
            </span>

            <v-divider></v-divider>
            <v-list nav dense>
                <v-list-item-group color="primary">
                    <router-link :to="`/${product.toUpperCase()}`"
                                 v-for="(product, idx) in $store.state.home.user.products" :key="idx">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>{{ $t(`icon.${product.toUpperCase()}`)}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ product }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <router-link v-if="showExportOption" to="/export">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-file-download</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Data Export History</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <router-link to="/LearningResources">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>menu_book</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Learning Resources</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
    import {EventBus} from '../../../../_helpers'

    export default {
        name: 'SideBar',
        data() {
            return {
                drawer: true,
                mini: true,
                fav: true,
                menu: false,
                item: '',
                message: false,
                hints: true,
                smallImage: true
            }
        },
        methods: {
            handleSideBar: function () {
                this.mini = !this.mini
                this.smallImage = !this.smallImage
            },
            handleSideBarMobile: function () {
                this.drawer = !this.drawer
            },
        },
        computed: {
            showExportOption: function () {
                return ['ROLE_HQ_OFFICER_DASHBOARD'].includes(this.$store.state.home.user.role)
            },
            getUserRole() {
                return this.$store.state.home.user.role
            },
            isUserAuthenticated() {
                return this.$store.state.home.authenticated
            }
        },
        created() {
            EventBus.$on('Clicked', this.handleSideBar)
            EventBus.$on('Sidebar', this.handleSideBarMobile)
        }
    }
</script>
<style>
    .v-application a {
        color: darkblue;
        text-decoration: none;
    }
</style>
